import React, {Component} from 'react'
import { connect } from 'react-redux'
// import Datetime from 'react-datetime'

// import styles
import './closingdays.scss'

// Actions
import { getClosingDaysInformation, saveClosingDaysInformation } from '../../../actions/settings'

// Utils
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

// Elements
import Panel from '../../../shared/elements/panel'
import Col from '../../../shared/elements/col'
import Inline from '../../../shared/elements/inline'
import Label from '../../../shared/elements/label'
import Text from '../../../shared/elements/text'
import DateTime from '../../../shared/elements/datetime'
import Grid from '../../../shared/elements/grid'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'

class ClosingDays extends Component {

  constructor (props) {
    super(props)
    this.state = {
      NewItem: {
        Date: '',
        Text: '',
        IsChangeable: true,
        IsDeleted: false
      },
      ClosingDays: {
        ShopId: 0,
        Days: [
          {
            Id: 0,
            Date: '',
            Text: '',
            IsChangeable: true,
            IsDeleted: false
          }
        ]
      },
      isLoading: false
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getClosingDaysInformation()
  }

  getClosingDaysInformation () {
    this.props.getClosingDaysInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        ClosingDays: {
          ShopId: res.data.ShopId,
          Days: res.data.Days
        }})
    }, (err) => {
      console.log(err)
    })
  }

  updateClosingDays (closingDays) {
    this.setState({ isLoading: true })
    return this.props.saveClosingDaysInformation(closingDays).then((res) => {
      this.setState({
        ClosingDays: {
          ShopId: res.data.ShopId,
          Days: res.data.Days
        }
      })
      return res
    }, (err) => {
      console.log(err)
      return err
    }).finally(() => this.setState({ isLoading: false }))
  }

  onChange (e) {
    let value = e.target.value
    this.setState({
      ClosingDays: {
        ...this.state.ClosingDays,
        [e.target.name]: value
      }
    })
  }

  onBlur (e) {
    this.props.saveClosingDaysInformation(this.state.ClosingDays).then(() => {
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1718'), translation('13424'))
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1719'), translation('216'))
    })
  }

  renderClosingDays () {
    let { ClosingDays } = this.state
    const deleteItem = (key) => {
      let closingDays = {...this.state.ClosingDays}
      closingDays.Days[key].IsDeleted = true
      this.updateClosingDays(ClosingDays)
    }

    const renderNew = () => {
      const addItem = () => {
        const formatDate = (date) => {
          if (date === null || date === '') return '1990-01-01'
          if (typeof date.format === 'function') {
            return date.format('YYYY-MM-DD')
          }
          return date
        }

        let ClosingDays = {...this.state.ClosingDays}
        let newItem = {...this.state.NewItem}
        newItem.Date = formatDate(newItem.Date)
        ClosingDays.Days.push(newItem)
        this.updateClosingDays(ClosingDays).then((res) => {
          this.setState({
            NewItem: {
              Date: '',
              Text: '',
              IsDeleted: false,
              IsChangeable: true
            }
          })
          // Toastr (replace dict. key)
          // window.toastr.success(translation('1718'), translation('13424'))
        }, () => {
          // Toastr (replace dict. key)
          window.toastr.error(translation('1719'), translation('216'))
        })
      }

      const onChange = (e) => {
        let value = ''
        let name = ''
        if (typeof e.target !== 'undefined') {
          value = e.target.value
          name = e.target.name
        } else {
          value = e
          name = 'Date'
        }
        this.setState({
          NewItem: {
            ...this.state.NewItem,
            [name]: value
          }
        })
      }

      let inputProps = {
        name: 'Date',
        placeholder: translation('1728'),
        readOnly: true
      }

      return (
        <Grid cols={[1, 1.75, 0.25]} spacing={1}>
          <DateTime
            // labelText={translation('388')}
            inputProps={inputProps}
            dateFormat='DD-MM-YYYY'
            timeFormat={false}
            closeOnSelect
            value={this.state.NewItem.Date}
            onChange={onChange} />
          <Text name='Text' value={this.state.NewItem.Text} onChange={onChange} />
          <AddButton spacing={0} onClick={addItem} disabled={this.state.isLoading} />
        </Grid>
      )
    }

    const renderClosingDay = (val, key) => {
      const renderChangable = (val, key) => {
        const onChange = (e) => {
          let closingDayNew = {...this.state.ClosingDays}
          closingDayNew.Days[key][e.target.name] = e.target.value
          this.setState({
            ClosingDays: closingDayNew
          })
        }

        return (
          <Grid key={key} cols={[1, 1.75, 0.25]} spacing={1}>
            <Label>{renderFullDate(val.Date, false)}</Label>
            <Text name='Text' key={'closingDayText_' + val.Id} defaultValue={val.Text} onChange={onChange} onBlur={this.onBlur} size='m' />
            <RemoveButton spacing={0} onClick={deleteItem.bind(this, key)} size='m' />
          </Grid>
        )
      }

      const renderUnchangable = (val, key) => {
        return (
          <Inline key={key}>
            <Label>{renderFullDate(val.Date, false)}</Label>
            <Label>{val.Text}</Label>
          </Inline>
        )
      }

      return val.IsChangeable ? renderChangable(val, key) : renderUnchangable(val, key)
    }

    return (
      <div>
        <Grid cols={[1, 1.75, 0.25]} spacing={1}>
          <Label>{translation('388')}</Label>
          <Label>{translation('333')}</Label>
          <div />
        </Grid>
        {renderNew()}
        {ClosingDays.Days.map(renderClosingDay)}
      </div>
    )
  }

  render () {
    return (
      <div className='closing-days'>
        <Col span={'2'}>
          <Panel title={translation('504')} helpText={translation('1985')}>
            {this.renderClosingDays()}
          </Panel>
        </Col>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getClosingDaysInformation,
  saveClosingDaysInformation
})(ClosingDays)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/ClosingDays/index.js